import { useState, useRef, useCallback } from 'react';
import { CloseIcon, SearchIcon } from './Icons';
import './SearchBar.css';

interface Props {
  onSearch?: (query: string) => void;
}

export default function SearchBar({ onSearch }: Props) {
  const [value, setValue] = useState('');
  const timer = useRef<ReturnType<typeof setTimeout>>();

  const handleChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const v = e.target.value;
    setValue(v);

    if (timer.current) clearTimeout(timer.current);

    timer.current = setTimeout(() => {
      if (onSearch) onSearch(v);
    }, 300);
  }, [onSearch]);

  function handleKeyDown(e: React.KeyboardEvent) {
    if (e.key === 'Enter' && onSearch) {
      if (timer.current) clearTimeout(timer.current);
      onSearch(value);
    }
  }

  function handleClear() {
    setValue('');
    if (timer.current) clearTimeout(timer.current);
    onSearch?.('');
  }

  return (
    <div className="search-bar-wrapper section-shell">
      <div className="search-bar surface-card">
        <SearchIcon className="search-icon" size={20} />
        <input
          type="text"
          className="search-input"
          placeholder="Buscar por código, nome, marca ou referência..."
          value={value}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          aria-label="Buscar produtos"
        />
        {value && (
          <button type="button" className="search-clear" onClick={handleClear} aria-label="Limpar busca">
            <CloseIcon size={16} />
          </button>
        )}
      </div>
    </div>
  );
}
